import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import PlansSection from './components/PlansSection';
import BenefitsSection from './components/BenefitsSection';
import SpeedTestSection from './components/SpeedTestSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import { cities } from './data/mock';

function App() {
  const [selectedCity, setSelectedCity] = useState(null);

  useEffect(() => {
    // Load saved city from localStorage
    const savedCity = localStorage.getItem('selectedCity');
    if (savedCity) {
      const city = cities.find(c => c.id === parseInt(savedCity));
      if (city) setSelectedCity(city);
    }
  }, []);

  const handleCityChange = (city) => {
    setSelectedCity(city);
    localStorage.setItem('selectedCity', city.id.toString());
  };

  return (
    <div className="App min-h-screen bg-[#0a1628]">
      {/* Noise Overlay for texture */}
      <div className="noise-overlay" />
      
      {/* Scan Line Effect */}
      <div className="scan-line" />
      
      <Header selectedCity={selectedCity} onCityChange={handleCityChange} />
      
      <main>
        <HeroSection selectedCity={selectedCity} />
        <PlansSection selectedCity={selectedCity} />
        <BenefitsSection />
        <SpeedTestSection />
        <FAQSection />
      </main>
      
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
